module.exports = "<div :class=divClasses> <btn type=floating :large=true :icon=icon :light-wave=lightWave :disabled=disabled></btn> <slot></slot> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ../~/vue-html-loader!../~/vue-loader/lib/selector.js?type=template&index=0!../~/material-ui-vue/components/buttons/fixed-action-button.vue
 ** module id = 158
 ** module chunks = 0
 **/